export function Monitoring() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Monitoring</h1>
      <p className="text-sm text-slate-500">Real-time system monitoring and metrics.</p>
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <p className="text-slate-400">Monitoring charts and metrics will appear here.</p>
      </div>
    </div>
  )
}
